import { z } from 'zod';

export const resultsTourGeneralEssDtoSchema = z
  .object({
    score: z.number(),
    maxScore: z.number(),
    topics: z.object({
      PARITY_EQUALITY: z.object({
        score: z.number(),
        maxScore: z.number(),
        sections: z.object({
          ARTISTIC_TEAM: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
          OCCASIONAL_OPERATIONAL_TEAM: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
          PERMANENT_PRODUCTION_TEAM: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
          TRANSPARENCY_MANAGEMENT: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
        }),
      }),
      LOCAL_IMPACT_RSE_ENGAGEMENT: z.object({
        score: z.number(),
        maxScore: z.number(),
        sections: z.object({
          ECONOMIC_SOCIAL_IMPACT: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
        }),
      }),
      ACCESSIBILITY_SOCIAL_DIALOGUE: z.object({
        score: z.number(),
        maxScore: z.number(),
        sections: z.object({
          ACCESSIBILITY: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
          RISK_PREVENTION: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
          TEAM_MANAGEMENT: z.object({
            score: z.number(),
            maxScore: z.number(),
          }),
        }),
      }),
    }),
  })
  .optional();
